module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fast-mission-intro"
  }, [_c('xi-top'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content-out-wrapper"
  }, [_c('div', {
    staticClass: "content-inner-wrapper"
  }, [_c('div', {
    staticClass: "row-wrapper"
  }, [_c('img', {
    attrs: {
      "src": _vm.$store.state.IMG_HOST + 'fastMissionIntro/1.png'
    }
  }), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "row-wrapper"
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('span', {
    staticClass: "content-title"
  }, [_vm._v("化繁为简，一次试音就够了")]), _vm._v(" "), _c('span', {
    staticClass: "content"
  }, [_vm._v("在主播工作台-声音标签中按照要求上传您的试音文件。审核通过后，系统将持续为您寻找适合您演播的任务。告别繁琐试音，只要一次就够了。")]), _vm._v(" "), _c('router-link', {
    staticClass: "content-button",
    attrs: {
      "to": {
        name: 'anchorMyVoiceTag'
      }
    }
  }, [_vm._v("立刻录制上传您的声音标签")])], 1), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.$store.state.IMG_HOST + 'fastMissionIntro/2.png'
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row-wrapper"
  }, [_c('img', {
    attrs: {
      "src": _vm.$store.state.IMG_HOST + 'fastMissionIntro/3.png'
    }
  }), _vm._v(" "), _vm._m(2)])])]), _vm._v(" "), _c('div', {
    staticClass: "steps-out-wrapper"
  }, [_c('div', {
    staticClass: "steps-inner-wrapper"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "steps-wrapper"
  }, [_c('div', {
    staticClass: "step"
  }, [_c('img', {
    staticClass: "step-img",
    attrs: {
      "src": _vm.$store.state.IMG_HOST + 'fastMissionIntro/upload.png'
    }
  }), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('div', {
    staticClass: "step"
  }, [_c('img', {
    staticClass: "step-img",
    attrs: {
      "src": _vm.$store.state.IMG_HOST + 'fastMissionIntro/invitation.png'
    }
  }), _vm._v(" "), _vm._m(5)]), _vm._v(" "), _c('div', {
    staticClass: "step"
  }, [_c('img', {
    staticClass: "step-img",
    attrs: {
      "src": _vm.$store.state.IMG_HOST + 'fastMissionIntro/match.png'
    }
  }), _vm._v(" "), _vm._m(6)])])])]), _vm._v(" "), _c('xi-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner-out-wrapper"
  }, [_c('div', {
    staticClass: "banner"
  }, [_c('div', {
    staticClass: "large-slogan"
  }, [_vm._v("\n                推荐任务等你来抢\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "sub-slogan"
  }, [_vm._v("\n                有声化平台自动推荐功能上线\n            ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('span', {
    staticClass: "content-title"
  }, [_vm._v("除了参加海选，这样也能获得有声化任务")]), _vm._v(" "), _c('span', {
    staticClass: "content"
  }, [_vm._v("有声化平台任务发布系统进入2.0时代。不仅是您主动参与海选，我们也自动将为您推荐适合您的演播任务。您只需要选择您最擅长演播的书籍类型，按照要求上传试音，当有该类型合适的演播任务时，系统将自动向你发送录制邀约。获得演播机会，就是那么简单。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('span', {
    staticClass: "content-title"
  }, [_vm._v("系统推荐，快速抢单手慢无")]), _vm._v(" "), _c('span', {
    staticClass: "content"
  }, [_vm._v("当有合适的演播任务时，系统将通过手机短信和站内信的方式同时向数个主播发起邀约，最先登录主播工作台并抢到邀约的主播将获得播讲权。录制演播机会，手快有，手慢无。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "steps-slogan-wrapper"
  }, [_c('span', {
    staticClass: "slogan"
  }, [_vm._v("简单三步")]), _vm._v(" "), _c('span', {
    staticClass: "slogan"
  }, [_vm._v("轻松获得有声化任务")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "step-content"
  }, [_vm._v("1.登录主播工作台"), _c('br'), _vm._v("上传声音标签")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "step-content"
  }, [_vm._v("2.系统自动匹配"), _c('br'), _vm._v("演播任务")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "step-content"
  }, [_vm._v("3.收到任务邀约"), _c('br'), _vm._v("快速抢单")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a3b2b17a!./~/vue-loader/lib/selector.js?type=template&index=0!./views/specialTopic/FastMissionIntro.vue
// module id = 1127
// module chunks = 0